// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__2OIl8","containerTheme":"Footer_containerTheme__1ZCq3","titleTheme":"Footer_titleTheme__3mQNV"};